import { jsx as o } from "react/jsx-runtime";
import { B as p } from "../Box-a4eeb4ec.js";
import m from "react";
import "../index-057d60ee.js";
import "../_commonjsHelpers-c5d32002.js";
import "../identifier-2b569a98.js";
import "../generateUtilityClasses-b12a03ea.js";
import "../createTheme-ef7fa3a1.js";
import "../objectWithoutPropertiesLoose-1e2b28af.js";
import "../extends-e3d0fd9d.js";
import "../extends-0a3e0827.js";
import "../clsx-0c6e471a.js";
import "../extendSxProp-10687d60.js";
import "@emotion/styled";
import "@emotion/react";
import "../GlobalStyles-bdd9f9fb.js";
import "../useTheme-89580aa5.js";
import "../useThemeWithoutDefault-9240f28c.js";
const e = {
  clip: "rect(0 0 0 0)",
  clipPath: "inset(100%)",
  height: "1px",
  overflow: "hidden",
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
}, a = m.forwardRef(
  ({ sx: i = [], ...t }, r) => /* @__PURE__ */ o(
    p,
    {
      ref: r,
      sx: [e, ...Array.isArray(i) ? i : [i]],
      ...t
    }
  )
);
a.displayName = "VisuallyHidden";
export {
  a as default
};
//# sourceMappingURL=VisuallyHidden.js.map
